import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Pagination } from '../../shared/pagination.model';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { PagingResponseModel } from '../../shared/api-response.model';
import { Core2Config } from '../../shared/core2Config';
import { StockTakeDeviceModel } from '../../../../../../models/aggregates/erp/stock';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { StockTakeDeviceCriteriaModelQuery, StockTakeDeviceQueryCriteriaClass } from '../../../criteria/stock';

@Injectable({ providedIn: 'root' })
export class StockTakeDeviceService extends BaseApiTemplateService<StockTakeDeviceModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'stocktake/devices';

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'stocktake/devices';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'stocktake/devices';
    this.httpClient = theHttp;
  }

  getStockTakeDeviceByCriteria(visa: ApiVisa, criteria?: StockTakeDeviceQueryCriteriaClass):
    Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildStockTakeDeviceCriteria = new StockTakeDeviceCriteriaModelQuery(criteria);
    return this.httpClient.get<PagingResponseModel<any>>(this.apiUrl + '/query?' + buildStockTakeDeviceCriteria.query, this.getHttpHeader(visa));
  }

}
